import { render } from "./confirmedRequests.vue?vue&type=template&id=6fa9a800"
import script from "./confirmedRequests.vue?vue&type=script&lang=js"
export * from "./confirmedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__